import React from 'react';

import { ReviewReports } from '../components/Approvals/ReviewReports.component';

export const ReportApprovalsPage: React.FC = () => {
  return <ReviewReports />;
};
